import React from 'react';
import {
  UtilityBar, Nav, Hero, Manifesto, BringYourOwnTemplate,
  HowItWorks, Features, Methodology, CTA, Footer,
} from './components/sections.jsx';
import PeerSnapshot from './components/PeerSnapshot.jsx';

export default function App() {
  return (
    <>
      <UtilityBar />
      <Nav />
      <Hero />

      <section className="section" id="coverage" style={{ paddingTop: 80, paddingBottom: 60 }}>
        <div className="section-num">01 — LIVE SNAPSHOT</div>
        <div className="section-head">
          <h2>One screen. The whole <em>sector</em>. Ranked.</h2>
          <p>This is the same peer-comparison screen analysts use in-product. The rating column does the heavy lifting — click any header to re-sort and pick the names worth a deeper look.</p>
        </div>
        <PeerSnapshot />
        <div className="cap-row">
          <span className="on">● US Quick-Service Restaurants</span>
          <span>Industrials · Heavy</span>
          <span>EU Banks</span>
          <span>Mega-cap Tech</span>
          <span>Semiconductors</span>
          <span>Healthcare REITs</span>
          <span>Aerospace &amp; Defense</span>
          <span>Renewable Energy</span>
          <span>+ 39 more sectors</span>
        </div>
      </section>

      <Manifesto />
      <BringYourOwnTemplate />
      <HowItWorks />
      <Features />
      <Methodology />
      <CTA />
      <Footer />
    </>
  );
}
